import React, { useContext, useEffect, useState } from 'react';
import { Card, Navbar, Nav } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa';
import axios from 'axios';
import { site_url } from '../config.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { parseStoredAccessToken } from '../parseStoredAccessToken.js';
import { FormatDate } from '../Function';

function monthStart() {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  return `${d.getFullYear()}-${m}-01`;
}

function today() {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${m}-${day}`;
}

function money(amount) {
  return Number(amount || 0).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function Index() {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const [from, setFrom] = useState(monthStart());
  const [to, setTo] = useState(today());
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);

  const goBack = () => {
    window.history.back();
  };

  useEffect(() => {
    document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }, [location]);

  const loadReport = async () => {
    const token = parseStoredAccessToken(user);
    if (!token) return;
    setLoading(true);
    try {
      const res = await axios.get(`${site_url}/customer/report?from=${from}&to=${to}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      });
      if (res.data.status === 'success') {
        setSummary(res.data.summary || null);
      }
    } catch (error) {
      console.error('Error fetching customer report:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) loadReport();
  }, [user, from, to]);

  const cards = [
    { label: 'Total Purchase', value: summary?.total_purchase, color: 'text-primary' },
    { label: 'Bills', value: summary?.bills_count, money: false, color: 'text-dark' },
    { label: 'Reward Points Used', value: summary?.reward_used, color: 'text-danger' },
    { label: 'Reward Points Earned', value: summary?.reward_earned, color: 'text-success' },
    { label: 'Reward Points Expired', value: summary?.reward_expired, color: 'text-warning' },
    { label: 'Available to Redeem', value: summary?.available_to_redeem, color: 'text-success' },
  ];

  return (
    <div className="min-vh-100">
      <Navbar expand="lg" className="navbar px-3">
        <Navbar.Brand className="fw-bold text-white">
          <center>
            <FaArrowLeft onClick={goBack} className="fs-5 text-white notificaton-icon" /> My Report
          </center>
        </Navbar.Brand>
        <Nav className="ms-auto d-flex align-items-center" />
      </Navbar>

      <div className="p-3" style={{ marginBottom: '30%' }}>
        <Card className="mb-3">
          <Card.Body>
            <div className="row">
              <div className="col-6">
                <label className="form-label">From Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={from}
                  onChange={(e) => setFrom(e.target.value)}
                />
              </div>
              <div className="col-6">
                <label className="form-label">To Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={to}
                  onChange={(e) => setTo(e.target.value)}
                />
              </div>
            </div>
            <div className="text-center text-muted mt-2" style={{ fontSize: '13px' }}>
              {FormatDate(from)} – {FormatDate(to)}
            </div>
          </Card.Body>
        </Card>

        {loading ? (
          <div className="text-center p-4">
            <div className="spinner-border text-success" role="status" />
          </div>
        ) : summary ? (
          <div className="row">
            {cards.map((card) => (
              <div className="col-6 mb-3" key={card.label}>
                <div className="report-stat-box">
                  <div className="title">{card.label}</div>
                  <div className={`value ${card.color}`}>
                    {card.money === false ? (card.value || 0) : `${money(card.value)}`}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center text-muted p-4">No report data.</div>
        )}
        <p className="text-center text-muted mt-2" style={{ fontSize: '12px' }}>
          Available to Redeem is your current wallet balance.
        </p>
      </div>
    </div>
  );
}

export default Index;
